//===================>custom.js=========================>
//**** defer image loading until after page load
function init() {
    var imgDefer = document.getElementsByTagName("img");
    for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute("data-src")) {
            imgDefer[i].setAttribute(
                "src",
                imgDefer[i].getAttribute("data-src")
            );
        }
    }
}
window.onload = init;

//***** Directory, click to scroll (tidy scroll) to results
function scrollToAnchor(aid) {
    var aTag = $("[name='" + aid + "']");
    $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
}

$(".browse_all").click(function() {
    scrollToAnchor("franchiseDirectory");
});

$(window).on('load', function() {
    if (location.search.length > 0) scrollToAnchor("franchiseDirectory");
});

$(window).on('load', function() {
    if (location.hash.length > 0) scrollToAnchor(location.hash.substring(1));
});

window.addEventListener("hashchange", function(event) {
    scrollToAnchor(location.hash.substring(1));
});

$(window).on('load', function() {
    $("ul.expandible").each(function() {
        var e = $(this),
            n = e.find("li:gt(0)"),
            t = e.hasClass("expanded");
        n[t ? "show" : "hide"](),
            n.length > 0 &&
                e.append(
                    $(
                        '<li class="expand"><div>' +
                            (t
                                ? "View less franchising steps &and;"
                                : "View more franchising steps &or;") +
                            "</div></li>"
                    ).click(function(t) {
                        var a = e.hasClass("expanded");
                        t.preventDefault(),
                            $(this).html(
                                a
                                    ? "View more franchising steps &or;"
                                    : "View less franchising steps &and;"
                            ),
                            e.toggleClass("expanded"),
                            n.toggle();
                    })
                );
    });
});

$(document).ready(function() {
    $(".directory_tablet_results").click(function() {
        $(".franchise_filter").slideToggle();
    });
});

